import React, { useEffect, useState } from 'react';
import { Container, Typography, Grid, Card, CardContent, CardMedia, Button, CardActions } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { fetchProducts } from '../../services/api';
import { Product } from '../../types';

const Products: React.FC = () => {
    const navigate = useNavigate();
    const [products, setProducts] = useState<Product[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const loadProducts = async () => {
            try {
                const data = await fetchProducts();
                setProducts(data);
            } catch (err) {
                console.error('Erreur lors du chargement des produits:', err);
                setError(err instanceof Error ? err.message : 'Une erreur est survenue');
            } finally {
                setLoading(false);
            }
        };

        loadProducts();
    }, []);

    if (loading) {
        return (
            <Container>
                <Typography variant="h6">Chargement des produits...</Typography>
            </Container>
        );
    }

    if (error) {
        return (
            <Container>
                <Typography variant="h6" color="error">
                    Erreur: {error}
                </Typography>
            </Container>
        );
    }

    if (!products.length) {
        return (
            <Container>
                <Typography variant="h4" gutterBottom>
                    Aucun produit trouvé
                </Typography>
            </Container>
        );
    }

    return (
        <Container>
            <Typography variant="h4" component="h1" gutterBottom>
                Tous nos Produits ({products.length})
            </Typography>

            <Grid container spacing={4}>
                {products.map((product) => (
                    <Grid item xs={12} sm={6} md={4} key={product._id}>
                        <Card
                            sx={{
                                height: '100%',
                                display: 'flex',
                                flexDirection: 'column',
                            }}
                        >
                            <CardMedia
                                component="img"
                                height="200"
                                image={product.imageUrl || '/uploads/products/logo.svg'}
                                alt={product.name}
                                onError={(e) => {
                                    e.currentTarget.src = '/uploads/products/logo.svg';
                                }}
                            />
                            <CardContent sx={{ flexGrow: 1 }}>
                                <Typography gutterBottom variant="h6" component="h2">
                                    {product.name}
                                </Typography>
                                <Typography variant="body2" color="text.secondary" gutterBottom>
                                    {product.category?.name}
                                </Typography>
                                <Typography variant="body2" sx={{ fontSize: '0.875rem' }}>
                                    {product.description}
                                </Typography>
                                <Typography variant="h6" color="primary" sx={{ mt: 2 }}>
                                    {product.price}€
                                </Typography>
                            </CardContent>
                            <CardActions>
                                <Button
                                    size="medium"
                                    color="primary"
                                    onClick={() => navigate(`/product/${product._id}`)}
                                    sx={{
                                        fontSize: '1rem',
                                        fontWeight: 'bold',
                                        backgroundColor: '#1976d2',
                                        border: '2px solid #1976d2',
                                        color: 'white',
                                        '&:hover': {
                                            backgroundColor: '#1565c0',
                                            border: '2px solid #1565c0',
                                            color: 'white'
                                        }
                                    }}
                                >
                                    Voir et réserver
                                </Button>
                            </CardActions>
                        </Card>
                    </Grid>
                ))}
            </Grid>
        </Container>
    );
};

export default Products;